export const styles: { [key: string]: React.CSSProperties } = {
  container: {
    backgroundColor: "red",
    color: "white",
  },
};
